import * as React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

interface IRadioGroupProps {
  noLabelBlock?: boolean
  required?: boolean
  name: string
  selectedValue: any,
  onChange: (values: string) => void
  parseValue?: (value: string) => any
  options: Array<{
    label: string | JSX.Element
    value: any
    tooltip?: string
  }>
  insertOtherOption?: boolean
}

interface IRadioGroupState {
  numOfChanges: number
  isOtherChecked: boolean
}

class RadioGroup extends React.Component<IRadioGroupProps, IRadioGroupState> {
  state = {
    numOfChanges: 0,
    isOtherChecked: false
  }

  previousOtherValue: string
  otherInput: HTMLInputElement
  currentSelectedValue: any

  componentDidMount() {
    let otherValue: string
    this.currentSelectedValue = this.props.selectedValue

    const found = this.props.options.some((option) => {
      return this.props.selectedValue === option.value
    })

    if (!found) {
      otherValue = this.currentSelectedValue
    }

    if (otherValue) {
      this.previousOtherValue = otherValue
      if (this.otherInput) { this.otherInput.value = otherValue }

      this.setState({ isOtherChecked: true })
    }
  }

  update(e: React.ChangeEvent<HTMLInputElement>) {
    const value = e.currentTarget.value
    const numOfChanges = this.state.numOfChanges++
    const isOtherChecked = false

    this.updateValue(value)

    this.setState({ numOfChanges, isOtherChecked }, () => {
      if (this.otherInput) {
        this.otherInput.value = ''
      }

      this.previousOtherValue = undefined
    })
  }

  isChecked(value: string) {
    // tslint:disable-next-line:no-console
    //console.log('currentSelectedValue: ' + JSON.stringify(this.currentSelectedValue) + ' -- value: ' + value)
    // tslint:disable-next-line:triple-equals
    return this.currentSelectedValue == value
  }

  updateIsOtherChecked(e: React.ChangeEvent<HTMLInputElement>) {
    const isOtherChecked = e.currentTarget.checked

    if (isOtherChecked) {
      this.updateValue('')
    }

    this.setState({ isOtherChecked }, () => {
      if (isOtherChecked) {
        this.otherInput.focus()
      }
    })
  }

  updateOther(e: React.KeyboardEvent<HTMLInputElement>) {
    const { value } = e.currentTarget
    const numOfChanges = this.state.numOfChanges++

    this.updateValue(value)

    this.setState({ numOfChanges })
  }

  updateValue(value: string) {
    this.props.onChange(value)
    if (this.props.parseValue) {
      this.currentSelectedValue = this.props.parseValue(value)
    } else {
      this.currentSelectedValue = value
    }
  }

  render() {
    const labelStyle = this.props.noLabelBlock ? { marginRight: '1vw' } : { display: 'block' }
    return (
      <span>
        {this.props.options.map((option, index) =>
          <label key={option.value} style={labelStyle}>
            <input type="radio"
              name={this.props.name}
              value={option.value}
              checked={this.isChecked(option.value)}
              onChange={(e) => this.update(e)}
              required={this.props.required && index === 0}
            />&nbsp;&nbsp; {option.label}
            {option.tooltip ?
              <OverlayTrigger placement="right" overlay={<Tooltip id="RadioTooltip">{option.tooltip}</Tooltip>}>
                <span>
                  &nbsp;
                  <i className="fa fa-fw fa-info-circle" />
                </span>
              </OverlayTrigger>
              : null
            }
          </label>
        )}
        {this.props.insertOtherOption ?
          <label>
            <input type="radio"
              name={this.props.name}
              checked={this.state.isOtherChecked}
              onChange={(e) => this.updateIsOtherChecked(e)}
            />&nbsp;&nbsp;Other
            <span style={{ visibility: this.state.isOtherChecked ? 'visible' : 'hidden' }}>
              :&nbsp;&nbsp;
              <input type="text"
                name={this.props.name + 'Other'}
                ref={(input) => this.otherInput = input}
                className="plain-input"
                placeholder="Please specify"
                onKeyUp={(e) => this.updateOther(e)}
                required={this.state.isOtherChecked} />
            </span>
          </label>
          : null
        }
      </span>
    )
  }
}

export {
  RadioGroup
}



// WEBPACK FOOTER //
// ./src/app/components/form/RadioGroup/index.tsx